import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { EnvService } from '../services';
import { UserState } from '../store/user/user.state';

@Injectable({ providedIn: 'root' })
export class HttpAuthInterceptor implements HttpInterceptor {
  apiUrl: string = '';

  constructor(private store: Store, private envService: EnvService) {
    this.apiUrl = this.envService.api.baseUrl;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.toLowerCase().includes(this.apiUrl.toLowerCase())) {
      return next.handle(request);
    }

    const token = this.store.selectSnapshot(UserState.token);

    if (token && !request.headers.has('Authorization')) {
      request = request.clone({
        setHeaders: {
          Authorization: token,
        },
      });
    }

    return next.handle(request);
  }
}
